import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { HttpBaseService } from 'src/app/base/http-base.service';
import {
  deleteExposedApi,
  deleteExposedClient,
  deleteExposedComponent,
  getExposedAPIByClientId,
  getExposedAPIByComponentId,
  getExposedApiAdvanceSearch,
  getExposedApiAutoSuggest,
  getExposedClient,
  getExposedClientAdvanceSearch,
  getExposedClientAutoSuggest,
  getExposedComponentAdvanceSearch,
  getExposedComponentAutoSuggest,
  getExposedComponentByClientId,
  saveExposedApi,
  saveExposedApiBatch,
  saveExposedApiBatchState,
  saveExposedClient,
  saveExposedClientState,
  saveExposedComponent,
  saveExposedComponentState,
  setAPIByClientId,
  setAPIByComponentId,
  setComponentByClientId,
  setDeleteExposedApi,
  setDeleteExposedClient,
  setDeleteExposedComponent,
  setExposedApi,
  setExposedApiAdvanceSearch,
  setExposedApiAutosuggest,
  setExposedClient,
  setExposedClientAdvanceSearch,
  setExposedClientAutosuggest,
  setExposedClientTable,
  setExposedComponentAdvanceSearch,
  setExposedComponentAutosuggest,
} from '../actions/exposedrest.actions';
import { MessageService } from 'primeng/api';

@Injectable()
export class ExposedrestEffects {
  private actions$ = inject(Actions);
  private baseService = inject(HttpBaseService);
  private store = inject(Store);
  private messageService = inject(MessageService);

  getExposedClient$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedClient),
        map((action) => {
          if (!action.apiConstants?.method) {
            return;
          }
          this.baseService[action.apiConstants?.method](action.apiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedClientTable({ exposedClientTable: result }));
            }
          });
        })
      ),
    { dispatch: false }
  );

  // saveExposedClient$ = createEffect(() =>
  //     this.actions$.pipe(
  //         ofType(saveExposedClient),
  //         map((action) => this.baseService[action.saveAPiConstants?.method](action.saveAPiConstants, action.exposedClientData)
  //             .subscribe({
  //                 next: (result: any) => {
  //                     console.log(result);
  //                     this.store.dispatch(setExposedClient(
  //                         { exposedClient: result }
  //                     ));
  //                     this.store.dispatch(saveExposedClientState(
  //                         { success: true, exposedClient: result }
  //                     ));
  //                 }, error: (error: any) => {
  //                     if (error.ERROR_CODE===500) {
  //                         this.showMessage('error', 'Client with same name already exists');
  //                     } else if (error.ERROR_CODE===403) {
  //                         this.showMessage('error', 'Access restricted');
  //                     } else {
  //                         this.showMessage('error', 'Exception occured when creating a client', error);
  //                     }
  //                     this.store.dispatch(saveExposedClientState(
  //                         { success: false, exposedClient: action.exposedClientData }
  //                     ));
  //                 }
  //             }))),
  //     { dispatch: false }
  // );

  saveExposedClient$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveExposedClient),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.exposedClientData
          ).subscribe(
            (result) => {
              console.log(result);
              this.store.dispatch(setExposedClient({ exposedClient: result }));
              this.store.dispatch(saveExposedClientState({ success: true, exposedClient: result }));
            },
            (err: any) => {
              if (err.ERROR_CODE) {
                console.log(err.ERROR_CODE);
              }
              this.store.dispatch(saveExposedClientState({ success: false, exposedClient: action.exposedClientData }));
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveExposedApi$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveExposedApi),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](action.saveAPiConstants, action.exposedApiData).subscribe(
            (result: any) => {
              if (result) {
                this.store.dispatch(
                  setExposedApi({
                    exposedApi: result
                  })
                );
              }
            }
          )
        )
      ),
    { dispatch: false }
  );

  saveExposedComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveExposedComponent),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.exposedComponentData
          ).subscribe({
            next: (result) => {
              console.log(result);
              this.store.dispatch(saveExposedComponentState({ success: true, exposedComponent: result }));
            },
            error: (error: any) => {
              if (error.status === 500) {
                this.showMessage('error', 'Component with same name already exists');
              } else if (error.status === 403) {
                this.showMessage('error', 'Access restricted');
              } else {
                this.showMessage('error', 'Exception occured when creating a component', error);
              }
              this.store.dispatch(
                saveExposedComponentState({ success: true, exposedComponent: null })
              );
            }
          })
        )
      ),
    { dispatch: false }
  );

  saveExposedApiBatch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(saveExposedApiBatch),
        map((action) =>
          this.baseService[action.saveAPiConstants?.method](
            action.saveAPiConstants,
            action.exposedApiDataBatch
          ).subscribe(
            (result: any) => {
              if (result) {
                console.log(result);
                this.store.dispatch(
                  setAPIByComponentId({ componentId: result[0].componentId, exposedAPIByComponent: result })
                );
                this.store.dispatch(
                  saveExposedApiBatchState({ success: true, exposedApiBatch: action.exposedApiDataBatch })
                );
              }
            },
            (_error) => {
              this.showMessage('error', 'An API already exists, please refresh and check');
              this.store.dispatch(saveExposedApiBatchState({ success: false, exposedApiBatch: null }));
            }
          )
        )
      ),
    { dispatch: false }
  );

  getExposedAPIByComponentId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedAPIByComponentId),
        map((action) =>
          this.baseService[action.getExposedAPIByComponentIdApi?.method](
            action.getExposedAPIByComponentIdApi,
            action.params
          ).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(
                setAPIByComponentId({ componentId: action.params.functionalcompid, exposedAPIByComponent: result })
              );
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedAPIByClientId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedAPIByClientId),
        map((action) =>
          this.baseService[action.apiConstants?.method](action.apiConstants, action.params).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setAPIByClientId({ clientId: action.params.clientId, exposedAPIByClient: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  setAPIByClientId;

  getExposedComponentByClientId$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedComponentByClientId),
        map((action) =>
          this.baseService[action.getExposedComponentByClientIdApi?.method](
            action.getExposedComponentByClientIdApi,
            action.params
          ).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setComponentByClientId({ exposedComponentByClient: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  deleteExposedClient$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteExposedClient),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteExposedClient({ deletedClient: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteExposedComponent$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteExposedComponent),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteExposedComponent({ deletedComponent: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  deleteExposedApi$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(deleteExposedApi),
        map((action) => {
          if (!action.deleteApiConstants?.method) {
            return;
          }
          this.baseService[action.deleteApiConstants.method](action.deleteApiConstants, action.ids).subscribe(
            (result: any) => {
              this.store.dispatch(setDeleteExposedApi({ deletedApi: true }));
            }
          );
        })
      ),
    { dispatch: false }
  );

  getExposedComponentAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedComponentAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedComponentAutosuggest({ componentAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedApiAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedApiAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedApiAutosuggest({ apiAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedClientAutoSuggest$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedClientAutoSuggest),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedClientAutosuggest({ clientAutosuggestResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedComponentAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedComponentAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedComponentAdvanceSearch({ componentAdvanceSearchRsults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedApiAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedApiAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedApiAdvanceSearch({ apiAdvanceSearchResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  getExposedClientAdvanceSearch$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(getExposedClientAdvanceSearch),
        map((action) =>
          this.baseService[action.getApiConstants?.method](action.getApiConstants).subscribe((result: any) => {
            if (result) {
              this.store.dispatch(setExposedClientAdvanceSearch({ clientAdvanceSearchtResults: result }));
            }
          })
        )
      ),
    { dispatch: false }
  );

  showMessage(status: string, message: string, detail?: string) {
    this.messageService.clear();
    this.messageService.add({
      life: 10000,
      severity: status,
      summary: message,
      detail: detail
    });
  }
}
